import React from 'react';

const AudiLogo = ({ className = "h-10 w-auto" }) => {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
        <circle cx="17" cy="50" r="15" fill="#000000" />
        <circle cx="39" cy="50" r="15" fill="#000000" />
        <circle cx="61" cy="50" r="15" fill="#000000" />
        <circle cx="83" cy="50" r="15" fill="#000000" />
      </svg>
    </div>
  );
};

export default AudiLogo;